import React from "react"

const DieuKhoanBaoMat = () => {
  return (
    <>
      <p>
        <strong>ĐIỀU KHOẢN BẢO MẬT</strong>
      </p>

      <p>
        <strong>
          <em>(Áp dụng từ ngày 21/8/2025)</em>
        </strong>
      </p>

      <p>
        <strong>1. Chính sách bảo mật thông tin cá nhân khách hàng</strong>
      </p>

      <p>
        Nhằm đảm bảo an toàn cho dịch vụ và bảo mật thông tin cho khách hàng, ON Live TV đưa ra một số chính sách bảo
        mật thông tin cho khách hàng đăng ký mở tài khoản.
      </p>

      <p>
        <strong>1.1 Mục đích thu thập thông tin</strong>
      </p>

      <p>- Cung cấp sản phẩm, hàng hóa, dịch vụ cho Khách hàng.</p>

      <p>- Thực hiện các nghĩa vụ của VTVlive theo quy định pháp luật.</p>

      <p>
        - Lưu trữ và cung cấp thông tin theo yêu cầu của cơ quan nhà nước có thẩm quyền theo quy định của pháp luật.
      </p>

      <p>- Nâng cao chất lượng hàng hóa, sản phẩm, dịch vụ của VTVlive cung cấp cho Khách hàng.</p>

      <p>
        - Tiếp thị, quảng cáo, giới thiệu sản phẩm, hàng hóa, dịch vụ và hoạt động có tính chất thương mại khác phù hợp
        với nhu cầu của Khách hàng hoặc VTVlive cho rằng khách hàng quan tâm.
      </p>

      <p>- Nghiên cứu thị trường, thăm dò dư luận, môi giới</p>

      <p>- Tổ chức giới thiệu và xúc tiến thương mại.</p>

      <p>
        Khách hàng có quyền đồng ý hoặc không đồng ý cho phép Công ty thu thập, xử lý dữ liệu cá nhân qua thiết lập kỹ
        thuật xin sự đồng ý.
      </p>

      <p>
        <strong>1.2. Phạm vi thu thập thông tin</strong>
      </p>

      <p>Chúng tôi cũng thu thập các thông tin sau của bạn:</p>

      <p>
        - Thông tin cá nhân: bao gồm các thông tin bạn cung cấp cho chúng tôi để xác nhận tài khoản như tên hiển thị, số
        điện thoại và email.
      </p>

      <p>- Các thông tin liên quan đến thiết bị, hành vi sử dụng các dịch vụ của ON Live TV.</p>

      <p>
        <strong>2. Thời gian lưu trữ thông tin</strong>
      </p>

      <p>
        - ON Live TV sẽ lưu trữ các Thông tin cá nhân do Khách hàng cung cấp trên các hệ thống nội bộ của chúng tôi
        trong suốt quá trình sử dụng dịch vụ và trong vòng 02 (hai) năm kể từ khi Khách hàng chấm dứt sử dụng dịch vụ.
      </p>

      <p>
        <strong>3. Địa chỉ của đơn vị thu thập và quản lý thông tin cá nhân</strong>
      </p>

      <p>- Công ty Cổ phần Truyền hình tương tác Việt Nam.</p>

      <p>- Trụ sở: Số 3 ngõ 84 Ngọc Khánh, Giảng Võ, Hà Nội.</p>

      <p>- Tổng đài liên hệ: 1900.866.666 (miễn phí).</p>

      <p>
        <strong>4. Phương tiện và công cụ để người dùng tiếp cận và chỉnh sửa dữ liệu cá nhân</strong>
      </p>

      <p>
        - Khách hàng có thể thực hiện các quyền trên bằng cách tự truy cập vào ON Live TV để sử dụng và update thông
        tin, hệ thống sẽ tự động cập nhật dữ liệu mới theo thông tin số điện thoại và thiết bị và phiên bản hệ điều hành
        đang sử dụng.
      </p>

      <p>
        - Khách hàng có thể kiểm tra các thiết bị đã đăng nhập: Cá nhân / Quản lý thiết bị
        <br />- Lịch sử xem trên ON Live TV.
      </p>

      <p>
        - Khách hàng có thể phản ánh chất lượng, nội dung không phù hợp thông qua tính năng báo cáo tại màn hình trình
        chiếu nội dung.
      </p>

      <p>
        <strong>5. Cam kết bảo mật thông tin cá nhân khách hàng</strong>
      </p>

      <p>
        Chúng tôi cam kết giữ bí mật tất cả các thông tin mà bạn cung cấp cho Công ty Cổ phần Truyền hình tương tác Việt
        Nam hoặc thông tin chúng tôi thu thập được từ bạn và không tiết lộ với bất kỳ bên thứ ba nào trừ khi có yêu cầu
        từ Cơ quan Nhà nước có thẩm quyền.
      </p>

      <p>
        <strong>6. Liên kết đến ứng dụng khác</strong>
      </p>

      <p>
        Dịch vụ cung cấp một số liên kết tới trang Web hoặc nguồn dữ liệu khác. Quý khách tự chịu trách nhiệm khi sử
        dụng các liên kết này ON Live TV không tiến hành thẩm định hay xác thực nội dung, tính chính xác, quan điểm thể
        hiện tại các trang Web và nguồn dữ liệu liên kết này. ON Live TV từ chối bất cứ trách nhiệm pháp lý nào liên
        quan tới tính chính xác, nội dung thể hiện, mức độ an toàn và việc cho hiển thị hay che đi các thông tin trên
        các trang Web và nguồn dữ liệu nói trên.
      </p>

      <p>
        <strong>7. Liên kết từ ứng dụng khác</strong>
      </p>

      <p>
        Chúng tôi không cho phép bất kỳ nhà cung cấp dịch vụ Internet nào được phép &quot;đặt toàn bộ&quot; hay
        &quot;nhúng&quot; bất kỳ thành tố nào của ON Live TV làm thay đổi giao diện/hiển thị mặc định của ON Live TV mà
        chưa có sự đồng ý của ON Live TV.
      </p>

      <p>
        <strong>8. Giải quyết khiếu nại</strong>
      </p>

      <p>
        Bất kỳ khiếu nại nào phát sinh trong quá trình sử dụng dịch vụ, Khách hàng có thể gửi yêu cầu về Công ty Cổ phần
        Truyền hình Tương tác Việt Nam:
      </p>

      <p>- Trụ sở chính: Số 3 Ngõ 84 Ngọc Khánh, phường Giảng Võ, Thành phố Hà Nội</p>

      <p>- Hotline: 1900.866.666 (miễn phí)</p>

      <p>
        - Email: <a href="mailto:hotro@onlive.vn">hotro@onlive.vn</a>
      </p>

      <p>Chi tiết về quy trình, thủ tục quy định tại Quy trình tiếp nhận và giải quyết khiếu nại.</p>

      <p>
        <strong>9. Dịch vụ ON Live TV không có chức năng đặt hàng trực tuyến</strong>
      </p>

      <p>
        <strong>10. Thông tin về chủ sở hữu</strong>
      </p>

      <p>- Công ty Cổ phần Truyền hình tương tác Việt Nam.</p>

      <p>
        - Giấy chứng nhận đăng ký doanh nghiệp số 0105941484 do Phòng Đăng ký kinh doanh và Tài chính doanh nghiệp cấp
        thay đổi lần thứ 17 ngày 11 tháng 9 năm 2025.
      </p>

      <p>- Trụ sở: Số 3 ngõ 84 Ngọc Khánh, Giảng Võ, Hà Nội.</p>

      <p>- Tổng đài chăm sóc khách hàng: 1900.866.666 (miễn phí).</p>

      <p>
        - Giấy phép cung cấp dịch vụ phát thanh và truyền hình trả tiền số 100/GP-BVHTTDL do Bộ Văn hóa, Thể thao và Du
        lịch cấp sửa đổi lần 1 ngày 21 tháng 8 năm 2025.
      </p>
    </>
  )
}

export default DieuKhoanBaoMat
